export default "__VITE_ASSET__BhmmdM6N__"